import React from "react";
import { TContainerStateProps } from "./../../state/TContainerStateProps";
import { CRMTitleSection } from "../../components/CRMTitleSection/CRMTitleSection";
import { CRMSpacer } from "../../components/CRMSpacer/CRMSpacer";
import { CRMAutosaveIndicatorWrap } from "../../components/CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { CRMCodecEditForm } from "../../components/CRMCodecEditForm/CRMCodecEditForm";
import { CaseAuctionDetails } from "../../../../domain/codecs/CasesContractBlock";
import { SpacingColumn } from "../../components/BuildingBlocks/SpacingColumn";
import { CRMSpacing } from "../../models/CRMSpacing";

const CRMLegalCaseDetailsContractAuctionContainer = (props: TContainerStateProps): JSX.Element =>
    <CRMAutosaveIndicatorWrap
        status={props.state.forms.contracts_block.children.details.status}
    >
        <CRMTitleSection>
            Auction
        </CRMTitleSection>
        <CRMSpacer size="large" />

        <SpacingColumn spacing={CRMSpacing.MEDIUM}>
            <CRMCodecEditForm
                codec={CaseAuctionDetails}
                model={props.state.forms.contracts_block.children.details.edited}
                validationErrors={props.state.forms.contracts_block.children.details.validationErrors}
                columns={2}
                onChange={(edited) => props.dispatch({
                    type: "LEGAL_CASE_CONTRACTS_BLOCK_CHANGE",
                    payload: {
                        ...props.state.forms.contracts_block.children.details,
                        edited: {
                            ...props.state.forms.contracts_block.children.details.edited,
                            ...edited,
                        }
                    }
                })}
                showDeferDateLabels={true}
            />
        </SpacingColumn>
    </CRMAutosaveIndicatorWrap>;

export default CRMLegalCaseDetailsContractAuctionContainer;
